import React, { useEffect, useState } from 'react'
import Game from './Game'
import { Progress, mainState, pos } from './types'

declare global {
  interface Window {
    game: Progress,
  }
}
window.game = {isTopBlack: true, moves: [], inHistory: 0};

export default function App() {
  const [state, setState] = useState<mainState>({state: 'play', isTopBlack: true});
  // useEffect(() => {
  // }, [state])
  return (
    <>
      <Game state={state} changeState={setState} />
    </>
  )
}





/**
 * 1. 
 */